<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <FormInput :label="$t('formularios.dni')" name="dni" rules="required" id="dni" v-model="abonado.dni" />
        <button type="submit" :disabled="abonadoSeleccionado" class="button large-button effect-button"><span>{{ $t('partido.buscar') }}</span></button>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['abonado', 'abonadoSeleccionado'],
        data() {
            return {
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.terminar();
                }
            },
            terminar() {
                this.$emit('terminado');
            }
        },
        computed: {
            teatro(){
                return this.$store.getters.getTeatro;
            },
        }
    }
</script>
